import * as React from 'react';

import { Box, Step, StepLabel, Stepper } from '@mui/material';
import { STEPS } from '../constants/societyData';
import { ReminderCreationStep } from '../types/reminderPublisherTypes';

interface ReminderStepperContentProps {
    currentStep: ReminderCreationStep;
    children: React.ReactNode;
}

/**
 * Composant pour afficher le stepper et le contenu de l'étape courante
 */
export const ReminderStepperContent: React.FunctionComponent<ReminderStepperContentProps> =
    function ({ currentStep, children }) {
        // Conversion de l'étape en index numérique
        const stepIndexMap: Record<ReminderCreationStep, number> = {
            society: 0,
            suggestion: 1,
            message: 2,
        };

        const activeStep = stepIndexMap[currentStep];

        return (
            <Box sx={{ maxWidth: '90vw' }}>
                <Box sx={{ p: 3, pb: 0 }}>
                    <Stepper
                        activeStep={activeStep}
                        alternativeLabel
                    >
                        {STEPS.map((label) => (
                            <Step key={label}>
                                <StepLabel>{label}</StepLabel>
                            </Step>
                        ))}
                    </Stepper>
                </Box>
                {children}
            </Box>
        );
    };

export default ReminderStepperContent;
